import { Vector2 } from '@technology/web3d';
import { type MapProjection } from '@trimble/web3d-plugin-features-service';

const FEATURES_MODEL_ID = 'feature-extraction';
export const ROOT_ZOOM_LEVEL = 8;
export const FEATURE_TILE_IMAGE_SIZE = 256;
export const FEATURE_TILE_MAX_ZOOM_LEVEL = 21;
export const FEATURE_TILE_MIN_ZOOM_LEVEL = 15;

const WEB_MERCATOR_MAX_EXTENT = 20037508.342789244;
export const WEB_MERCATOR_PROJECTION: MapProjection = {
  proj4def:
    '+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs',
  bounds: [
    new Vector2(-WEB_MERCATOR_MAX_EXTENT, -WEB_MERCATOR_MAX_EXTENT),
    new Vector2(WEB_MERCATOR_MAX_EXTENT, WEB_MERCATOR_MAX_EXTENT),
  ] as [Vector2, Vector2],
};

export function modelIdForPointCloud(pointCloudId: string): string {
  return `${FEATURES_MODEL_ID}:${pointCloudId}`;
}
